/**
 * Centralised registry of top-level cws2.0 route paths (as declared in app-routing.module.ts)
 * so features linking to another module don't hardcode the path string in multiple places.
 * The app uses HashLocationStrategy (RouterModule.forRoot(routes, { useHash: true })), so any
 * plain <a href> to one of these routes must be prefixed with '#' — use cws2RouteHref for that.
 */
export const CWS2_ROUTES = {
  FAMILY_NAME_CHANGE: 'family-name-change',
  ADDRESS_TELEPHONE_CHANGE: 'address-telephone-change',
} as const;

export type Cws2Route = (typeof CWS2_ROUTES)[keyof typeof CWS2_ROUTES];

/** Router.navigate command array for a top-level cws2.0 route, e.g. router.navigate(cws2RouteCommands(CWS2_ROUTES.FAMILY_NAME_CHANGE)) */
export function cws2RouteCommands(route: Cws2Route): string[] {
  return [`/${route}`];
}

/** Hash-prefixed href for use in plain <a href> attributes, honoring HashLocationStrategy */
export function cws2RouteHref(route: Cws2Route): string {
  return `#/${route}`;
}
